import { IncidentModel } from './incident.model';
export class RegistrationModel extends IncidentModel {
    public insuranceCompany: string;
    public insurancePolicy: string;
}
